import { useEffect, useState } from 'react';
import { api, fmt } from '../api';

export default function Reddit() {
  const [products, setProducts] = useState<any[]>([]);
  const [productId, setProductId] = useState<string>('');
  const [subreddits, setSubreddits] = useState<any[]>([]);
  const [insights, setInsights] = useState<any[]>([]);
  const [templates, setTemplates] = useState<any | null>(null);
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    api.products().then((rows) => {
      setProducts(rows);
      if (rows.length) setProductId(rows[0].id);
    });
    api.redditSubreddits().then((r) => setSubreddits(r.subreddits));
    api.redditInsights().then(setInsights);
  }, []);

  async function genTemplates(subredditName: string) {
    if (!productId) return;
    const r = await api.redditTemplates(productId, subredditName);
    setTemplates(r);
  }

  const pains = insights.filter((i) => i.kind === 'pain');
  const desires = insights.filter((i) => i.kind === 'desire');

  return (
    <>
      <h2 className="page-title">Reddit Insights</h2>
      <p className="page-sub">Subreddit intelligence + manual post templates. Reddit campaign writes are not enabled at launch.</p>

      <div className="compliance-banner">
        <b>Compliance:</b> ScaleAds AI does not post to Reddit on your behalf. All organic post templates are generated for manual use from your own account.
      </div>

      <div className="field" style={{ maxWidth: 400 }}>
        <label>Product</label>
        <select value={productId} onChange={(e) => setProductId(e.target.value)}>
          {products.map((p) => (
            <option key={p.id} value={p.id}>{p.title}</option>
          ))}
        </select>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20, marginTop: 16 }}>
        <div>
          <div className="card card-padded" style={{ marginBottom: 16 }}>
            <div className="card-title">Recommended subreddits</div>
            {subreddits.map((s) => (
              <div key={s.id} className="reddit-sub">
                <div className="reddit-score">{Math.round(s.rank_score * 100) / 100}</div>
                <div>
                  <div className="name">r/{s.name}</div>
                  <div className="meta">
                    {fmt.num(s.subscribers)} subs · topics: {s.topics}
                  </div>
                  <div style={{ marginTop: 4, display: 'flex', gap: 6 }}>
                    <span className={`pill-policy ${s.allows_promo ? 'ok' : ''}`}>
                      {s.allows_promo ? 'promo ok' : 'strict promo'}
                    </span>
                    <span className={`pill-policy ${s.allows_link ? 'ok' : ''}`}>
                      {s.allows_link ? 'links allowed' : 'no links'}
                    </span>
                  </div>
                </div>
                <div className="spacer" />
                <button className="btn btn-small" onClick={() => genTemplates(s.name)}>
                  Generate templates
                </button>
              </div>
            ))}
          </div>

          {templates && (
            <div className="card card-padded">
              <div className="card-title">
                Manual post templates — r/{templates.subreddit.name}
                <button className="btn btn-small" onClick={() => setTemplates(null)}>Close</button>
              </div>
              <div className="compliance-banner">{templates.compliance_notice}</div>
              <div style={{ marginBottom: 12, fontSize: 12, color: 'var(--text-sub)' }}>
                <b>Rules reminder:</b> {templates.subreddit.rules}
              </div>
              {templates.templates.map((t: any, i: number) => (
                <div key={i} style={{ marginBottom: 20 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <div>
                      <b style={{ textTransform: 'capitalize' }}>{t.kind.replace('_', ' & ')}</b>
                      <div style={{ fontSize: 14, marginTop: 4 }}>{t.title}</div>
                    </div>
                    <button
                      className="btn btn-small"
                      onClick={() => {
                        navigator.clipboard.writeText(`${t.title}\n\n${t.body}`);
                        setCopied(String(i));
                        setTimeout(() => setCopied(null), 1600);
                      }}
                    >
                      {copied === String(i) ? '✓ Copied' : 'Copy'}
                    </button>
                  </div>
                  <div className="template-body">{t.body}</div>
                  <div style={{ marginTop: 6, fontSize: 11, color: 'var(--text-mute)' }}>
                    Best posting time: {t.bestTime}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div>
          <div className="card card-padded" style={{ marginBottom: 16 }}>
            <div className="card-title">Pain points (mined)</div>
            {pains.length === 0 ? <div className="empty">No pain data yet.</div> : pains.map((p) => (
              <div key={p.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ fontSize: 13 }}>{p.text}</div>
                <div style={{ fontSize: 11, color: 'var(--text-mute)', marginTop: 2 }}>
                  r/{p.subreddit_name} · score {p.score.toFixed(2)}
                </div>
              </div>
            ))}
          </div>
          <div className="card card-padded">
            <div className="card-title">Desires (mined)</div>
            {desires.length === 0 ? <div className="empty">No desire data yet.</div> : desires.map((p) => (
              <div key={p.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <div style={{ fontSize: 13 }}>{p.text}</div>
                <div style={{ fontSize: 11, color: 'var(--text-mute)', marginTop: 2 }}>
                  r/{p.subreddit_name} · score {p.score.toFixed(2)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
